/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=f80c58d2&scoped=true"
import script from "./AppHeader.ts?vue&type=script&lang=ts&external"
export * from "./AppHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=f80c58d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c58d2",
  null
  
)

export default component.exports